import { getInitials } from "@/shared/utils/getInitials";
import { Avatar, AvatarFallback } from "../shadcn/Avatar";
import { cn } from "@/shared/utils/cn";

interface InitialsAvatarProps {
  firstName: string;
  lastName: string;
  size?: number | string; // e.g. 40 or '2.5rem'
  className?: string;
}

export function InitialsAvatar({
  firstName,
  lastName,
  size = 40,
  className = "",
}: InitialsAvatarProps) {
  const initials = getInitials(firstName, lastName);
  const dimension = typeof size === "number" ? `${size}px` : size;

  return (
    <Avatar
      className={cn("rounded-xl font-bold select-none", className)}
      style={{
        width: dimension,
        height: dimension,
        fontSize: `max(12px, calc(${dimension} * 0.35))`,
      }}
      title={initials}
      data-telemetry-mask
    >
      <AvatarFallback className="rounded-xl bg-secondary text-primary">{initials}</AvatarFallback>
    </Avatar>
  );
}
